import i18n from 'typescript/application/i18n';

/**
 * Provides a wrapper to the i18n.t function to allow for translating
 * strings outside of React components
 * @param key the translation key
 * @param options any options to pass to the translation function
 * @returns string the translated string
 */
const t = (key: string, options?: Record<string, any>): string => {
  // make sure i18n is initialized before trying to translate
  if (i18n.isInitialized) {
    return i18n.t(key, options);
  }

  i18n.on('loaded', () => {
    return i18n.t(key, options);
  });

  i18n.on('languageChanged', () => {
    return i18n.t(key, options);
  });

  // return the key if i18n is not initialized
  return key;
};

export default t;
